export function endsWithNumber(str: string) {
  return /\d$/.test(str);
}
